import common from '@/locales/zh-CN/common'
import products from '@/locales/zh-CN/products'
import charging_packages from '@/locales/zh-CN/charging_packages'
import refund_tasks from '@/locales/zh-CN/refund_tasks'
import road_book from '@/locales/zh-CN/road_book'
import order from '@/locales/zh-CN/order'
import stationActivity from '@/locales/zh-CN/station_activity'

const locales = {
  ...road_book,
  ...common,
  ...products,
  ...charging_packages,
  ...refund_tasks,
  ...order,
  ...stationActivity
}

export { locales as default }
